import { Box, Grid, Typography } from '@mui/material';
import { CoinsCounterProps, UserCounters } from '../types';

import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';
import gold_coin from '../assets/gold_coin.json';
import { useLocation } from 'react-router-dom';

interface UserBannerScoresProps {
  userCounters?: UserCounters | null;
  coinsData?: CoinsCounterProps | null;
  isMobile: Boolean | null;
  clanCounters?: any | null;
  clanCoins?: number | null;
  clanId?: string | null;
}

const UserBannerScores: React.FC<UserBannerScoresProps> = ({
  userCounters,
  coinsData,
  isMobile,
  clanCounters,
  clanCoins,
  clanId
}) => {
  const location = useLocation();
  console.log('location.pathname', location.pathname);
  const isClan = location.pathname === `/clan/${clanId}`;
  const sideScores = (
    <Grid item xs={4} md={4} sx={{ mt: { xs: 1, md: 2 } }}>
      <Grid container spacing={1} sx={{ mt: isMobile ? 0 : '-30px' }}>
        <Grid item xs={6}>
          <Player
            autoplay
            loop
            src={gold_coin}
            style={isMobile ? { width: '80%', height: '80%' } : { width: 80, height: 80 }}
          />
        </Grid>
      </Grid>
      <Grid item container alignItems="center" justifyContent="center" textAlign="center" spacing={3}>
        <Typography
          fontSize={{ xs: '16.43px', md: '31px' }}
          sx={{
            padding: isMobile ? '20px 0 0 0' : '5px 0 0 0',
            fontFamily: 'Baloo2',
            marginLeft: isMobile ? '-35px' : clanId ? '-65px' : 0
          }}>
          {coinsData?.coins ? coinsData?.coins?.toString().padStart(4, '0') : clanCoins || '0000'}
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        width: isClan ? (isMobile ? '90%' : '80%') : '100%',
        justifyContent: 'center',
        boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.15)',
        border: '1px solid',
        borderImageSource:
          'linear-gradient(180deg, rgba(252, 252, 252, 0.2) 0%, rgba(150, 150, 150, 0.2) 47%, rgba(133, 129, 129, 0.2) 97%)',
        padding: 2,
        borderRadius: '24px',
        backdropFilter: 'blur(12px)',
        margin: isClan ? '5%' : 0
      }}>
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        {isMobile && sideScores}

        <Grid item xs={8} md={8}>
          <Grid container spacing={1} direction="column">
            {[
              {
                name: 'Activity',
                score: userCounters && userCounters?.cws ? userCounters?.cws : clanCounters?.cws,
                gradient: 'linear-gradient(90deg, #081058 -151.39%, #7E31E1 -18.16%, #9421CD 100%)',
                shadow: 'rgba(14, 0, 60, 0.5)'
              },
              {
                name: 'Popularity',
                score: userCounters?.cps ? userCounters?.cps : clanCounters?.cps,
                gradient: 'linear-gradient(181.5deg, #EE4343 -2.29%, #FF0000 99.25%)',
                shadow: 'rgba(255, 175, 1, 0.5)'
              },
              {
                name: 'Benevolence',
                score: userCounters?.cgs ? userCounters?.cgs : clanCounters?.cgs,
                gradient: ' linear-gradient(233.66deg, #FFAE01 19.66%, #FF8F01 77.25%)',
                shadow: 'rgba(238, 67, 67, 0.5)'
              },
              {
                name: 'Achievement',
                score: userCounters?.cas ? userCounters?.cas : clanCounters?.cas,
                gradient: 'linear-gradient(90deg, #14BA56 0%, #FFC700 100%)',
                shadow: 'rgba(20, 186, 86, 0.5)'
              }
            ].map(({ name, score, gradient, shadow }) => (
              <Grid item key={name} container alignItems="center">
                <Grid item xs={8} md={8} sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      position: 'relative',
                      width: '16px',
                      height: '16px',
                      borderRadius: '50%',
                      background: gradient,
                      boxShadow: `0 4px 10px ${shadow}`,
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '-3px',
                        left: '-3px',
                        right: '-3px',
                        bottom: '-3px',
                        background: gradient,
                        borderRadius: '50%',
                        opacity: 0.4,
                        zIndex: -1,
                        whiteSpace: 'nowrap'
                      }
                    }}
                  />
                  <Typography fontSize={{ xs: '9.43px', md: '16.79px' }} sx={{ ml: 2 }}>
                    {name} Score
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={4}
                  md={4}
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    fontFamily: 'Baloo2'
                  }}>
                  <Typography fontSize={{ xs: '9.43px', md: '16.79px' }} sx={{ mx: 2 }}>
                    :
                  </Typography>
                  <Typography fontSize={{ xs: '9.43px', md: '16.79px' }} fontWeight={800}>
                    {score || 0}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
        {!isMobile && sideScores}
      </Grid>
    </Box>
  );
};

export default UserBannerScores;
